<template>
  <b-row>
    <b-col sm="12" md="6">
      <b-form-select v-model="id_module" :options="list_modules" size="sm" @input="$emit('changeSelectedModule', id_module)"></b-form-select>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: ["list_modules", "old_id_module"],
  data() {
    return {
      id_module: null,
    };
  },
  created() {
    if (this.old_id_module) {
      this.id_module = this.old_id_module;
    }
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/component/Import/AssociationModule.vue